import { render } from "./Typography.vue?vue&type=template&id=29efb4e7"
import script from "./Typography.vue?vue&type=script&lang=js"
export * from "./Typography.vue?vue&type=script&lang=js"
script.render = render

export default script